export const agGridTextSelectionProps = {
    enableCellTextSelection: true,
} as const
